<template>
  <ancestryline-modal title="dataTable.protocol.filters" id="modal-protocol-filters" :close="true" @close="close" :loading="false">
    <form @submit.prevent="applyFilter" @keydown.enter.prevent="applyFilter">
      <card :header="$t('forms.protocol.card-information')" class="p-col-12" >
        <coff-input-text v-model="filters.code" label="forms.protocol.code" class="p-col-12 p-md-6 p-lg-6" @keydown.enter.prevent="applyFilter"/>
        <coff-input-text v-model="filters.name" label="forms.protocol.name" class="p-col-12 p-md-6 p-lg-6" @keydown.enter.prevent="applyFilter"/>
        <coff-input-text v-model="filters.family_name" label="forms.protocol.family-name" class="p-col-12 p-md-6 p-lg-6" @keydown.enter.prevent="applyFilter"/>
        <coff-input-select v-model="filters.status" label="dataTable.protocol.columns.status" class="p-col-12 p-md-6 p-lg-6" :options="statusList" option-value="id"/>
        <CoffInputRadio v-model="filters.budget" @update="forceUpdateField('budget', $event)" :options="budgetOptions" class="p-col-12 p-md-12 p-lg-12"/>
        <coff-input-auto-complete v-model="filters.person_id" label="forms.protocol.client" class="p-col-12 p-md-6 p-lg-6" :itens="clients" field="name" :func-suggestions="searchClient" @keydown.enter.prevent="applyFilter"/>
      </card>

    </form>

    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.clear')" @click.prevent="clearFilter" class="p-button-secondary p-mr-auto"/>
        <Button :label="$t('btn.filter')" @click.prevent="applyFilter" class="float-right p-button-primary"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";
import ClientBusiness from "@/business/ClientBusiness";
import {STATUS_PROTOCOL} from "@/constants/StatusProtocol";

export default {
  name: "ModalProtocolFilter",

  props: {
    showTypeProtocolFilter: {type: Boolean,  default: false},
    filters: {},
  },

  data() {
    return {
      clients: [],
      statusList: STATUS_PROTOCOL,
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
      budgetOptions: [
        {value: true, label: 'dataTable.protocol.columns.budget'},
        {value: false, label: 'dataTable.protocol.columns.protocol'},
        {value: null, label: 'btn.all'}
      ]
    }
  },

  methods:{

    async searchClient(name){
      return await ClientBusiness.search(name);
    },

    forceUpdateField(field, value){
      this.$set(this.filters, field, value);
    },

    close(){
      DialogService.closeModal();
    },

    clearFilter(){
      this.filters.name = null;
      this.filters.code = null;
      this.filters.family_name = null;
      this.filters.person_id = null;
      this.filters.status = null;
      this.filters.budget = null;
    },

    applyFilter(){
      DialogService.closeModal(this.filters);
    },

  },

}
</script>

<style scoped>

</style>